import { AxiosRequestConfig, AxiosResponse } from 'axios';

import AbstractCRMApi from '../../AbstractCRMApi';
import LotteryTicket from '../../Models/LotteryTicket';
import User from '../../Models/User';
import GetLotteryTicketResponse from '../Responses/LotteryTicketResponse';
import GetPaginatedResponse from '../Responses/PaginatedResponse';
import GetUserActivityResponse from '../Responses/UserActivityResponse';

class UsersApi extends AbstractCRMApi {
    public endpoint: string = 'user';

    public getById(userId: number, transformStateAndCountry: boolean = true): Promise<User> {
        const transformStateAndCountryFields = transformStateAndCountry ? '' : undefined;

        return this.get(`/${userId}`, { params: { transformStateAndCountryFields } }).then((response: AxiosResponse) =>
            UsersApi.mapDataToUserClass(response.data)
        );
    }

    public getAll(page: number = 1, config?: AxiosRequestConfig): Promise<GetPaginatedResponse<User>> {
        return this.get('', {
            ...config,
            params: { ...config?.params, page },
        }).then((response: AxiosResponse<GetPaginatedResponse>) => {
            return AbstractCRMApi.mapPaginatedDataToModel(response.data, User);
        });
    }

    public store(user: User): Promise<User> {
        return this.post('', user).then((response: AxiosResponse) => UsersApi.mapDataToUserClass(response.data));
    }

    public update(user: User): Promise<User> {
        return this.patch(`/${user.id}`, user).then((response: AxiosResponse) =>
            UsersApi.mapDataToUserClass(response.data)
        );
    }

    public getActivity(userId: number): Promise<GetUserActivityResponse> {
        return this.get(`/${userId}/activity`).then((response: AxiosResponse) => response.data);
    }

    public getTickets(
        userId: number,
        page: number = 1,
        multidrawId?: number,
        config?: AxiosRequestConfig
    ): Promise<GetPaginatedResponse<LotteryTicket>> {
        return this.get(`/${userId}/tickets`, {
            ...config,
            params: {
                ...config.params,
                page,
                multidrawId,
            },
        }).then((response: AxiosResponse<GetPaginatedResponse<GetLotteryTicketResponse>>) => {
            return AbstractCRMApi.mapPaginatedDataToModel(response.data, LotteryTicket);
        });
    }
}

export default new UsersApi();
